import Vue from 'vue'
import VueRouter from 'vue-router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios';

import App from './App.vue'
import AuthMixin from './mixins/auth.mixin';

import router from './router'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.mixin(AuthMixin)

Vue.prototype.$http = axios;

new Vue({
    render: h => h(App),
    router,
}).$mount('#app')
